import { axiosInstance } from '../../../shared/api';

export function getAccessToken() {
	const data = localStorage.getItem('accessToken');
	const response = data;
	return response;
}
const accessToken = getAccessToken();

export async function incomesGerCategoriesRequest() {
	try {
		const response = await axiosInstance.get(`incomes/categories`, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		return response.data;
	} catch (error) {
		throw new Error(`Failed to get model info: ${error.message}`);
	}
}
export async function incomesGerSourcesRequest() {
	try {
		const response = await axiosInstance.get(`incomes/sources`, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		return response.data;
	} catch (error) {
		throw new Error(`Failed to get model info: ${error.message}`);
	}
}
export async function incomesCreateRequest(userData) {
	// Use description as note if provided, otherwise set to empty string
	userData.note = userData.description || userData.note || '';
	try {
		const response = await axiosInstance.post(`incomes/incomes`, userData, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

/**
 * @param {object} [params]
 * @param {number} [params.skip]
 * @param {number} [params.limit]
 * @param {string[]} [params.categoryIds] — UUID strings, repeated as category_ids=
 * @param {string} [params.startDate] — YYYY-MM-DD
 * @param {string} [params.endDate] — YYYY-MM-DD
 */
export async function getIncomesRequest(params = {}) {
	try {
		const search = new URLSearchParams();
		search.set('skip', String(params.skip ?? 0));
		search.set('limit', String(params.limit ?? 1000));
		if (params.startDate) search.set('start_date', params.startDate);
		if (params.endDate) search.set('end_date', params.endDate);
		if (params.categoryIds?.length) {
			params.categoryIds.forEach(id => search.append('category_ids', id));
		}
		const qs = search.toString();
		const url = `incomes/incomes${qs ? `?${qs}` : ''}`;
		const response = await axiosInstance.get(url, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		return response.data;
	} catch (error) {
		throw new Error(`Failed to get model info: ${error.message}`);
	}
}

export async function incomesUpdateRequest(incomeId, userData) {
	// Use description as note if provided, otherwise keep existing note or set to empty string
	userData.note = userData.description || userData.note || '';
	try {
		const response = await axiosInstance.put(
			`incomes/incomes/${incomeId}`,
			userData,
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

export async function incomesDeleteRequest(incomeId) {
	try {
		const response = await axiosInstance.delete(`incomes/incomes/${incomeId}`, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		if (response.status === 200 || response.status === 204) {
			return response;
		}
	} catch (error) {
		console.error(error);
		throw error;
	}
}

export async function recurringIncomesCreateRequest(userData) {
	try {
		const response = await axiosInstance.post(`recurring-incomes`, userData, {
			withCredentials: true,
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

export async function getRecurringIncomesRequest() {
	try {
		const response = await axiosInstance.get(
			`recurring-incomes?skip=0&limit=100&is_active=true`,
			{
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		return response.data;
	} catch (error) {
		throw new Error(`Failed to get recurring incomes: ${error.message}`);
	}
}

export async function recurringIncomesUpdateRequest(
	recurringIncomeId,
	userData,
) {
	// Use description as note if provided, otherwise keep existing note or set to empty string
	userData.note = userData.description || userData.note || '';
	try {
		const response = await axiosInstance.put(
			`recurring-incomes/${recurringIncomeId}`,
			userData,
			{
				withCredentials: true,
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		if (response.status === 200) {
			return response;
		}
	} catch (error) {
		console.error(error);
		return error;
	}
}

export async function recurringIncomesDeleteRequest(recurringIncomeId) {
	try {
		const response = await axiosInstance.delete(
			`recurring-incomes/${recurringIncomeId}`,
			{
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			},
		);
		if (response.status === 200 || response.status === 204) {
			return response;
		}
	} catch (error) {
		console.error(error);
		throw error;
	}
}
